
























import { Component, Prop, Vue } from "vue-property-decorator";

type InputType = "iban" | "tckn" | "vkn" | "hesapNo";

@Component
export default class Number extends Vue {
  @Prop({ required: true }) label!: string;
  @Prop({ default: "12" }) md!: string;
  @Prop() value!: string;
  @Prop({ default: true }) required!: boolean;
  @Prop({ required: false }) type!: InputType;
  @Prop({ default: false }) loading?: boolean;
  @Prop() errorMessage?: string;
  @Prop() hint?: string;

  @Prop({ type: Number, default: null }) externalMin!: number | null;
  @Prop({ type: Number, default: null }) externalMax!: number | null;

  private debounceTimeout: number | null = null;

  get inputType(): string {
    return "text";
  }

  get maxLength(): number {
    if (this.externalMax !== null) {
      return this.externalMax;
    }
    switch (this.type) {
      case "iban":
        return 24;
      case "tckn":
        return 11;
      case "vkn":
        return 11;
      case "hesapNo":
        return 12;
      default:
        return 255;
    }
  }

  get prefix(): string {
    return this.type === "iban" ? "TR" : "";
  }

  get placeholder(): string {
    switch (this.type) {
      case "iban":
        return "__ ____ ____ ____ ____ ____";
      case "tckn":
        return "___________";
      case "vkn":
        return "__________";
      default:
        return "";
    }
  }

  get formattedValue(): string {
    if (!this.value) return "";
    if (this.type === "iban") {
      return this.value.replace(/(.{4})/g, "$1 ").trim();
    } else if (this.type === "hesapNo") {
      return this.value.replace(/(.{4})/g, "$1 ").trim();
    }
    return this.value;
  }

  onKeyPress(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    let pastedData = clipboardData.getData("text");
    if (/[^0-9]/.test(pastedData)) {
      event.preventDefault();
      pastedData = pastedData.replace(/[^0-9]/g, "");
      this.updateValue(pastedData);
    }
  }

  get validationRules() {
    const rules: ((v: string) => boolean | string)[] = [];
    if (this.required) {
      rules.push((v: string) => !!v || "Bu alan zorunludur");
    }
    if (this.externalMin !== null) {
      rules.push(
          (v: string) =>
              (v && this.externalMin && v.length >= this.externalMin) ||
              `En az ${this.externalMin} hane girilmelidir.`
      );
    }
    switch (this.type) {
      case "iban":
        rules.push(this.ibanValidation);
        break;
      case "tckn":
        rules.push(this.tcknValidation);
        break;
      case "vkn":
        rules.push(this.vknValidation);
        break;
      case "hesapNo":
        rules.push(this.hesapNoValidation);
        break;
    }
    return rules;
  }

  private ibanValidation(v: string): boolean | string {
    if (!v) return true;
    const cleaned = v.replace(/\s/g, "");
    if (!/^[0-9]{24}$/.test(cleaned)) {
      return "Geçerli bir IBAN giriniz (24 hane sayı)";
    }
    return true;
  }

  private tcknValidation(v: string): boolean | string {
    if (!v) return true;
    if (!/^[0-9]{11}$/.test(v)) {
      return "TC Kimlik No 11 haneli olmalıdır";
    }
    if (v[0] === "0") return "TC Kimlik No 0 ile başlayamaz";
    let odd = 0,
        even = 0,
        sum = 0;
    for (let i = 0; i < 9; i++) {
      if (i % 2 === 0) {
        odd += parseInt(v[i]);
      } else {
        even += parseInt(v[i]);
      }
    }
    sum = ((odd * 7) - even) % 10;
    if (sum !== parseInt(v[9])) return "Geçersiz TC Kimlik No";
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(v[i]);
    }
    if (sum % 10 !== parseInt(v[10])) return "Geçersiz TC Kimlik No";
    return true;
  }

  private vknValidation(v: string): boolean | string {
    return true;
    /*if (!v) return true;
    // Eğer VKN sadece 10 haneliyse:
    if (!/^[0-9]{10-11}$/.test(v)) {
      return "Vergi Kimlik No 10 veya 11 haneli olmalıdır";
    }
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      const digit = parseInt(v[i], 10);
      let multiply = (digit + 10 - (i + 1)) % 10;
      if (multiply === 0) multiply = 10;
      sum = (sum + (multiply * Math.pow(2, 9 - i)) % 10) % 10;
    }
    const lastDigit = (10 - (sum % 10)) % 10;
    return lastDigit === parseInt(v[9], 10) ? true : "Geçersiz Vergi Kimlik No";*/
  }


  private hesapNoValidation(v: string): boolean | string {
    if (!v) return true;
    if (!/^\d+$/.test(v)) {
      return "Hesap numarası sadece rakamlardan oluşmalıdır";
    }
    if (v.length !== 12) {
      return "Hesap numarası 12 haneli olmalıdır";
    }
    return true;
  }

  updateValue(value: string) {
    let processedValue = value;
    processedValue = processedValue.replace(/\s/g, "");
    processedValue = processedValue.replace(/[^0-9]/g, "");
    processedValue = processedValue.slice(0, this.maxLength);
    this.$emit("input", processedValue);
  }

  handleBlur() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    this.debounceTimeout = window.setTimeout(() => {
      const validationResult = this.validationRules
          .map(rule => rule(this.value))
          .find(result => result !== true);
      if (validationResult === undefined) {
        this.$emit("valid", this.value);
      } else {
        this.$emit("invalid", validationResult);
      }
    }, 300);
  }
}
